import { createContext } from 'react';
export const MobileCheckContext = /*#__PURE__*/createContext({
  isMobile: false
});